module.exports = __webpack_public_path__ + "static/media/16@2x.63da79d5.png";